<!-- PaymentSuccessModal.vue -->
<template>
    <b-modal v-model="showModal" title="Payment Successful" ok-only>
      <p>Your payment was successful! Thank you for your purchase.</p>
      <!-- <b-btn @click="closeModal" variant="success">Close</b-btn> -->
    </b-modal>
  </template>
  
  <script>
  export default {
    data() {
      return {
        showModal: false,
      };
    },
    methods: {
      openModal() {
        this.showModal = true;
        this.$eventHub.$emit('trial', 'active')

      },
      closeModal() {
        this.showModal = false;
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add your component-specific styles here */
  </style>
  